import { Configuration } from '@azure/msal-browser';
import { UserManagerSettings } from 'oidc-client-ts';
import React, { useMemo } from 'react';
import AuthProvider from '../auth/auth.provider';
import { AuthConfigurations } from '../auth/auth.types';
import { useConfig } from '../config/config.hook';
import { useModeloApresentacao } from '../config/internal/modelo-apresentacao/modelo-apresentacao.hook';
import { useToggles } from '../config/internal/toggles/toggles.hook';
import { AppInternalProps } from './app.types';

const isMsal = (predicate) => {
  const callBackMap = {
    true: undefined,
    false: undefined,
  };

  return {
    then: function (callback) {
      callBackMap.true = callback;
      return this;
    },
    orElse: function (callback) {
      callBackMap.false = callback;
      return this;
    },
    get: function () {
      return callBackMap[predicate.toString()]();
    },
  };
};

const AppInternal: React.FC<AppInternalProps> = ({ children, onLoading }: AppInternalProps) => {
  const { getValueOrThrow, getValue } = useConfig();
  const { isEnabled } = useToggles();
  const { modelo } = useModeloApresentacao();

  const configurations: AuthConfigurations = useMemo(() => {
    console.info('Iniciando a construção da configuração de autenticação');
    return isMsal(isEnabled('auth-msal') && modelo !== 'APP_ALUNO')
      .then(() => ({
        type: 'msal',
        dados: getValue<Configuration & { scope: string }>('msalConfiguration'),
      }))
      .orElse(() => ({
        type: 'oidc',
        dados: getValueOrThrow<UserManagerSettings>('userManagerSettings'),
      }))
      .get();
  }, [isEnabled, modelo, getValue, getValueOrThrow]);

  console.info('Inicializando o AppInternal');
  return (
    <AuthProvider configurations={configurations} onLoading={onLoading}>
      {children}
    </AuthProvider>
  );
};

export default AppInternal;
